import { gql } from "@apollo/client";

export const GET_LATEST_INVOICE_ANALYSIS = gql`
  query GetLatestInvoiceAnalysis {
    getLatestInvoiceAnalysis {
      id
      summary
      year2024To2025Change
      projected2026Total
      year2025To2026ProjectedChange
      lastTwoMonthsAnalysis
      peakMonthName
      lowestMonthName
      averageMonthlyCost
      seasonality
      predictionAnalysis
      anomaliesDetected
      anomaliesDetails
      recommendationAction
      recommendationSuggestion
      createdAt
    }
  }
`;

export const ANALYZE_INVOICES = gql`
  mutation AnalyzeInvoices {
    analyzeInvoices
  }
`;